require("../../../shared/job_edit.coffee")

$(->
  # INVITE BENCHMARK BUTTON

  $(document).on 'click', '#invite_benchmark_button', ->
    $.get($(this).data('template').replace('{{ID}}', $('#invite_benchmark_select').val()))
    false

  # PROMPT TO MOVE APPLICANTS TO NEW HIRING PROCESS WHEN JOB'S HIRING PROCESS IS CHANGED

  if $('#job_replace_hiring_process').length > 0
    $('#job_hiring_process_id').data('orig-value', $('#job_hiring_process_id').val())
    $('#job_hiring_process_id').on 'change', ->
      if $('#job_hiring_process_id').val() != $('#job_hiring_process_id').data('orig-value')
        $('#job_replace_hiring_process').modal('show')

  # Who can view this job's applicants? multiselect

  if $('#job_users_with_access').length > 0
    selected = $('#job_users_with_access').data('selected-ids').map (id) -> id.toString()
    $('#job_users_with_access').val(selected).select2({
      placeholder: 'Click to select'
    });

)
